import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  listContainer: {
    height: 413,
    maxHeight: 413,
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 261px)',
    },
  },
  articleCountContainer: {
    height: 20,
  },
  numOfArticles: {
    paddingLeft: 5,
    color: theme.palette.primary.main,
  },
  itemCardContainer: {
    padding: 5,
    margin: 5,
  },
  imageContainer: {
    position: 'relative',
    maxHeight: '250px',
  },
  image: {
    width: '100%',
    padding: '0 !important',
    zIndex: 1,
    borderRadius: 4,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardBox: {
    margin: theme.spacing(1, 0),
  },
  cardImageButton: {
    backgroundColor: theme.palette.base.red,
    color: theme.palette.base.white,
    borderRadius: 4,
    border: '1px solid white',
    position: 'absolute',
    width: '130px',
    left: '90px',
    bottom: '12%',
    [theme.breakpoints.down(400)]: {
      left: '73px',
    },
  },
  footer: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    borderTop: `1px solid ${theme.palette.base.lightGray}`,
  },
  itemCounter: {
    position: 'absolute',
    right: '10px',
    padding: '10px',
    background: theme.palette.base.red,
    color: theme.palette.base.white,
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    zIndex: 10,
  },
  itemDescription: {
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 3,
    wordBreak: 'keep-all',
    overflow: 'hidden',
    color: theme.palette.primary.headerText,
  },
}))

export default styles
